<h1>Vos avis et témoignages</h1>

<div class="container">
    <ul class="ps-0 row">
        <app-item-avis *ngFor="let item of listAvis" [avis]="item" class="col-12 col-sm-6 col-lg-4 col-xxl-3"></app-item-avis>
    </ul>
</div>
